// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.queryAns-container {
  display: flex;
  flex-direction: column;
  background-color: transparent;
  width: 100%;
  height: auto;
  padding: 1rem;
  box-sizing: border-box;
}

.conversation-profile {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  border: 2px solid var(--primary-color);
  background: #ffffff;
  padding: 2px;
}

.conversation-txt {
  font-size: 1rem;
  font-weight: 400;
  color: var(--text-color);
  line-height: 1.6rem;
  word-spacing: 0.05rem;
  width: 100%;
  text-align: left;
  margin: 0;
}

.query {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  margin-bottom: 20px;
}

/* Message Bubbles Common Styles */
.query-conversation-txt-container,
.ans-conversation-txt-container {
  position: relative;
  overflow: hidden;
  padding: 18px 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(0, 0, 0, 0.03);
}

/* User Message Card - Distinct Gray Aesthetic */
.query-conversation-txt-container {
  display: flex;
  flex-direction: column;
  margin-right: 15px;
  max-width: 75%;
  background-color: #e9ecef !important;
  /* More distinct gray bubble */
  border-radius: 20px 20px 4px 20px;
  color: var(--text-color);
  opacity: 1 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 16px 22px;
  position: relative;
  overflow: hidden;
  border: 1px solid #dee2e6 !important;
  transition: transform 0.2s ease;
}

.query-conversation-txt-container:hover {
  transform: translateY(-1px);
}

.query-conversation-txt-container .speaker {
  align-self: flex-start;
  filter: none;
  color: var(--primary-color);
  opacity: 0.5;
  margin-top: 10px;
}

.query-conversation-txt-container .speaker:hover {
  opacity: 1;
}

.query-conversation-txt-container .conversation-txt {
  color: var(--text-color);
}


/* Bot Message - Plain Text Look */
.ans-conversation-txt-container {
  background: transparent;
  display: flex;
  max-width: 85%;
  flex-direction: column;
  opacity: 1;
  box-shadow: none;
  border: none;
  padding: 10px 0;
}

.ans-conversation-txt-container::before {
  display: none;
}

@keyframes directed-shine {
  0% {
    left: -150%;
  }

  100% {
    left: 150%;
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(30px) scale(0.95);
  }

  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px) scale(0.95);
  }

  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.user-icon {
  margin-top: 5px;
  animation: fadeIn 0.5s ease-out forwards;
}

.ans {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 20px;
}

.bot-icon {
  margin-top: 5px;
  margin-right: 15px;
  animation: fadeIn 0.5s ease-out forwards;
}



.highlight {
  color: var(--primary-color);
  font-weight: 700;
  border-bottom: 2px solid var(--primary-color);
  padding-bottom: 1px;
}

@keyframes glow {
  from {
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
  }

  to {
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  }
}

.ans-content {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.speaker {
  width: 20px;
  height: 20px;
  cursor: pointer;
  filter: none;
  /* Dark color for white background */
  color: var(--primary-color);
  opacity: 0.7;
  transition: opacity 0.3s;
  display: inline-block;
  margin-top: 8px;
}

.ans-actions {
  display: flex;
  align-items: center;
  gap: 15px;
  /* Space between speaker and download button */
  margin-bottom: 12px;
  /* Small gap between actions and suggestions */
}

.speaker:hover {
  opacity: 1;
}

.download-btn,
.Linechart-btn {
  background: var(--secondary-color);
  color: var(--primary-color);
  padding: 12px 24px;
  margin-top: 20px;
  margin-right: 12px;
  border: 1px solid #d0d4d9;
  cursor: pointer;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 600;
  font-size: 0.875rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  letter-spacing: 0.3px;
}

.download-btn:hover,
.Linechart-btn:hover {
  background: var(--primary-color);
  color: #ffffff;
  border-color: var(--primary-color);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.download-btn:active,
.Linechart-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.download-icon,
.Line-icon {
  width: 16px;
  height: 16px;
  margin-right: 10px;
  opacity: 0.7;
  transition: opacity 0.25s ease;
}

.download-btn:hover .download-icon,
.Linechart-btn:hover .Line-icon {
  opacity: 1;
  filter: brightness(0) invert(1);
}

.suggested-questions-container {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  margin-bottom: 20px;
}

.suggested-header {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--primary-color);
  margin-bottom: 10px;
}

.suggested-questions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.suggested-question-btn {
  background: #ffffff;
  border: 1px solid var(--secondary-color);
  color: var(--text-color);
  padding: 8px 18px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  text-align: center;
  width: auto;
  max-width: none;
}

.suggested-question-btn:hover {
  background: var(--primary-color);
  color: #ffffff;
  border-color: var(--primary-color);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.chart-container {
  width: 100%;
  margin-top: 20px;
  background: transparent;
  padding: 0;
  border-radius: 0;
  border: none;
}

canvas {
  width: 100% !important;
  height: auto !important;
}

.loading-actions {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 10px;
}

.stop-btn {
  background: #fffafa;
  border: 1px solid #ff4d4f;
  color: #ff4d4f;
  padding: 4px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  transition: all 0.2s ease;
  height: -moz-fit-content;
  height: fit-content;
}

.stop-btn:hover {
  background: #ff4d4f;
  color: #ffffff;
}

.loading-container {
  display: flex;
  align-items: center;
  gap: 15px;
  background: rgba(248, 249, 250, 0.8) !important;
  border-radius: 12px;
  padding: 12px 20px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
}

.scanning-line {
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(90deg,
      transparent,
      rgba(51, 51, 51, 0.05),
      transparent);
  animation: scan 2s infinite ease-in-out;
  pointer-events: none;
}

@keyframes scan {
  0% {
    left: -100%;
  }

  100% {
    left: 200%;
  }
}

.loading-container .conversation-txt {
  font-weight: 500;
  color: var(--primary-color);
  font-size: 0.95rem;
  letter-spacing: 0.2px;
  min-width: 160px;
}

.spinner {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.dot1,
.dot2,
.dot3 {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin: 5px;
  background-color: var(--primary-color);
  animation: bounce 1.4s infinite ease-in-out both;
}

.dot1 {
  animation-delay: -0.32s;
}

.dot2 {
  animation-delay: -0.16s;
}

@keyframes bounce {

  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/queryAns/queryAns.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,iDAAiD;EACjD,qCAAqC;AACvC;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,oCAAoC;EACpC,8BAA8B;EAC9B,iCAAiC;EACjC,wBAAwB;EACxB,qBAAqB;EACrB,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA,kCAAkC;AAClC;EACE,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,wCAAwC;AAC1C;;;;AAIA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE;IACE,sCAAsC;EACxC;;EAEA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,oCAAoC;EACpC,2BAA2B;EAC3B,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8CAA8C;EAC9C,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,kCAAkC;EAClC,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kDAAkD;EAClD,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;;EAEE,gCAAgC;EAChC,cAAc;EACd,kCAAkC;EAClC,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iDAAiD;EACjD,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,kCAAkC;EAClC,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+CAA+C;EAC/C,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,YAAY;EACZ;;;kBAGgB;EAChB,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;;EAGE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".queryAns-container {\n  display: flex;\n  flex-direction: column;\n  background-color: transparent;\n  width: 100%;\n  height: auto;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n\n.conversation-profile {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 50%;\n  border: 2px solid var(--primary-color);\n  background: #ffffff;\n  padding: 2px;\n}\n\n.conversation-txt {\n  font-size: 1rem;\n  font-weight: 400;\n  color: var(--text-color);\n  line-height: 1.6rem;\n  word-spacing: 0.05rem;\n  width: 100%;\n  text-align: left;\n  margin: 0;\n}\n\n.query {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-start;\n  margin-bottom: 20px;\n}\n\n/* Message Bubbles Common Styles */\n.query-conversation-txt-container,\n.ans-conversation-txt-container {\n  position: relative;\n  overflow: hidden;\n  padding: 18px 25px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  border: 1px solid rgba(0, 0, 0, 0.03);\n}\n\n/* User Message Card - Distinct Gray Aesthetic */\n.query-conversation-txt-container {\n  display: flex;\n  flex-direction: column;\n  margin-right: 15px;\n  max-width: 75%;\n  background-color: #e9ecef !important;\n  /* More distinct gray bubble */\n  border-radius: 20px 20px 4px 20px;\n  color: var(--text-color);\n  opacity: 1 !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  padding: 16px 22px;\n  position: relative;\n  overflow: hidden;\n  border: 1px solid #dee2e6 !important;\n  transition: transform 0.2s ease;\n}\n\n.query-conversation-txt-container:hover {\n  transform: translateY(-1px);\n}\n\n.query-conversation-txt-container .speaker {\n  align-self: flex-start;\n  filter: none;\n  color: var(--primary-color);\n  opacity: 0.5;\n  margin-top: 10px;\n}\n\n.query-conversation-txt-container .speaker:hover {\n  opacity: 1;\n}\n\n.query-conversation-txt-container .conversation-txt {\n  color: var(--text-color);\n}\n\n\n/* Bot Message - Plain Text Look */\n.ans-conversation-txt-container {\n  background: transparent;\n  display: flex;\n  max-width: 85%;\n  flex-direction: column;\n  opacity: 1;\n  box-shadow: none;\n  border: none;\n  padding: 10px 0;\n}\n\n.ans-conversation-txt-container::before {\n  display: none;\n}\n\n@keyframes directed-shine {\n  0% {\n    left: -150%;\n  }\n\n  100% {\n    left: 150%;\n  }\n}\n\n@keyframes slideInRight {\n  from {\n    opacity: 0;\n    transform: translateX(30px) scale(0.95);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0) scale(1);\n  }\n}\n\n@keyframes slideInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-30px) scale(0.95);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0) scale(1);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.user-icon {\n  margin-top: 5px;\n  animation: fadeIn 0.5s ease-out forwards;\n}\n\n.ans {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-bottom: 20px;\n}\n\n.bot-icon {\n  margin-top: 5px;\n  margin-right: 15px;\n  animation: fadeIn 0.5s ease-out forwards;\n}\n\n\n\n.highlight {\n  color: var(--primary-color);\n  font-weight: 700;\n  border-bottom: 2px solid var(--primary-color);\n  padding-bottom: 1px;\n}\n\n@keyframes glow {\n  from {\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);\n  }\n\n  to {\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\n  }\n}\n\n.ans-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.speaker {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  filter: none;\n  /* Dark color for white background */\n  color: var(--primary-color);\n  opacity: 0.7;\n  transition: opacity 0.3s;\n  display: inline-block;\n  margin-top: 8px;\n}\n\n.ans-actions {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  /* Space between speaker and download button */\n  margin-bottom: 12px;\n  /* Small gap between actions and suggestions */\n}\n\n.speaker:hover {\n  opacity: 1;\n}\n\n.download-btn,\n.Linechart-btn {\n  background: var(--secondary-color);\n  color: var(--primary-color);\n  padding: 12px 24px;\n  margin-top: 20px;\n  margin-right: 12px;\n  border: 1px solid #d0d4d9;\n  cursor: pointer;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  font-weight: 600;\n  font-size: 0.875rem;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);\n  letter-spacing: 0.3px;\n}\n\n.download-btn:hover,\n.Linechart-btn:hover {\n  background: var(--primary-color);\n  color: #ffffff;\n  border-color: var(--primary-color);\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);\n  transform: translateY(-2px);\n}\n\n.download-btn:active,\n.Linechart-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n\n.download-icon,\n.Line-icon {\n  width: 16px;\n  height: 16px;\n  margin-right: 10px;\n  opacity: 0.7;\n  transition: opacity 0.25s ease;\n}\n\n.download-btn:hover .download-icon,\n.Linechart-btn:hover .Line-icon {\n  opacity: 1;\n  filter: brightness(0) invert(1);\n}\n\n.suggested-questions-container {\n  display: flex;\n  flex-direction: column;\n  margin-top: 15px;\n  margin-bottom: 20px;\n}\n\n.suggested-header {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--primary-color);\n  margin-bottom: 10px;\n}\n\n.suggested-questions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n}\n\n.suggested-question-btn {\n  background: #ffffff;\n  border: 1px solid var(--secondary-color);\n  color: var(--text-color);\n  padding: 8px 18px;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  font-weight: 500;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  text-align: center;\n  width: auto;\n  max-width: none;\n}\n\n.suggested-question-btn:hover {\n  background: var(--primary-color);\n  color: #ffffff;\n  border-color: var(--primary-color);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  transform: translateY(-1px);\n}\n\n.chart-container {\n  width: 100%;\n  margin-top: 20px;\n  background: transparent;\n  padding: 0;\n  border-radius: 0;\n  border: none;\n}\n\ncanvas {\n  width: 100% !important;\n  height: auto !important;\n}\n\n.loading-actions {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-top: 10px;\n}\n\n.stop-btn {\n  background: #fffafa;\n  border: 1px solid #ff4d4f;\n  color: #ff4d4f;\n  padding: 4px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  height: fit-content;\n}\n\n.stop-btn:hover {\n  background: #ff4d4f;\n  color: #ffffff;\n}\n\n.loading-container {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  background: rgba(248, 249, 250, 0.8) !important;\n  border-radius: 12px;\n  padding: 12px 20px;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);\n}\n\n.scanning-line {\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 50%;\n  height: 100%;\n  background: linear-gradient(90deg,\n      transparent,\n      rgba(51, 51, 51, 0.05),\n      transparent);\n  animation: scan 2s infinite ease-in-out;\n  pointer-events: none;\n}\n\n@keyframes scan {\n  0% {\n    left: -100%;\n  }\n\n  100% {\n    left: 200%;\n  }\n}\n\n.loading-container .conversation-txt {\n  font-weight: 500;\n  color: var(--primary-color);\n  font-size: 0.95rem;\n  letter-spacing: 0.2px;\n  min-width: 160px;\n}\n\n.spinner {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.dot1,\n.dot2,\n.dot3 {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin: 5px;\n  background-color: var(--primary-color);\n  animation: bounce 1.4s infinite ease-in-out both;\n}\n\n.dot1 {\n  animation-delay: -0.32s;\n}\n\n.dot2 {\n  animation-delay: -0.16s;\n}\n\n@keyframes bounce {\n\n  0%,\n  80%,\n  100% {\n    transform: scale(0);\n  }\n\n  40% {\n    transform: scale(1);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
